import gql from 'graphql-tag'

export const ApproveTrustedContactMutation = gql`
  mutation ApproveTrustedContactMutation($input: ApproveTrustedContactInput!) {
    approveTrustedContact(input: $input) {
      worker {
        id
      }
    }
  }
`
